/**
 * Custom hook for managing user settings
 */

import { useMutation } from "react-query";
import { getSupaClient } from "../../lib/supabase";

export default function useUserSettings() {
  const supabase = getSupaClient();

  const changeEmailRequest = async function ({ email }: { email: string }) {
    const session = await supabase.auth.session();
    const response = await fetch(
      `${process.env["REACT_APP_API_URL"]}/users/${
        session!.user?.id
      }/change-email`,
      {
        method: "PUT",
        body: JSON.stringify({ email }),
        headers: { Authorization: `Bearer ${session?.access_token}` },
      }
    );

    if (response.ok) return response.ok;
    throw { ...(await response.json()) };
  };

  const changePasswordRequest = async function ({
    password,
  }: {
    password: string;
  }) {
    const { error, data } = await supabase.auth.update({
      password,
    });
    if (data) return;
    throw error;
  };

  const changeEmail = useMutation(changeEmailRequest, {
    retry: false,
  });

  const changePassword = useMutation(changePasswordRequest, {
    retry: false,
  });

  return {
    changeEmail,
    changePassword,
  };
}
